// src/components/Layout/Layout.tsx
import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Sidebar from '../Sidebar/Sidebar';
import styles from './Layout.module.css';
import BackgroundLayer from '../Background/BackgroundLayer';

const Layout: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  const shouldRedirect = !isAuthenticated && location.pathname !== '/login';
  if (shouldRedirect) return <Navigate to="/login" replace />;

  return (
    <div className={styles.layoutContainer}>
      <aside className={styles.sidebarWrap}>
        <BackgroundLayer target="side" />
        <Sidebar />
      </aside>

      <div className={styles.mainContent}>
        <BackgroundLayer target="main" />
        <div className={styles.topBarSticky}></div>

        <div className={styles.content}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
